/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BrandChecks interface.
 */
export function instanceOfBrandChecks(value) {
    if (!('cert' in value) || value['cert'] === undefined)
        return false;
    if (!('dkim' in value) || value['dkim'] === undefined)
        return false;
    if (!('dmarc' in value) || value['dmarc'] === undefined)
        return false;
    if (!('http' in value) || value['http'] === undefined)
        return false;
    if (!('mx' in value) || value['mx'] === undefined)
        return false;
    if (!('ns' in value) || value['ns'] === undefined)
        return false;
    if (!('spf' in value) || value['spf'] === undefined)
        return false;
    return true;
}
export function BrandChecksFromJSON(json) {
    return BrandChecksFromJSONTyped(json, false);
}
export function BrandChecksFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'api': json['api'] == null ? undefined : json['api'],
        'cert': json['cert'],
        'dkim': json['dkim'],
        'dmarc': json['dmarc'],
        'http': json['http'],
        'mx': json['mx'],
        'ns': json['ns'],
        'spf': json['spf'],
    };
}
export function BrandChecksToJSON(json) {
    return BrandChecksToJSONTyped(json, false);
}
export function BrandChecksToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'api': value['api'],
        'cert': value['cert'],
        'dkim': value['dkim'],
        'dmarc': value['dmarc'],
        'http': value['http'],
        'mx': value['mx'],
        'ns': value['ns'],
        'spf': value['spf'],
    };
}
